module.exports = "/cyber/_next/static/images/2nd-place-prize-5ef1bb46ba57e83462400938eae5af67.png";